var _rect, _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoodResultsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 72,
    viewBox: "0 0 66 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#7C9179"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9563 27.0714L26.8708 42.1582C26.5407 42.4884 26.1487 42.7503 25.7174 42.929C25.286 43.1077 24.8237 43.1997 24.3568 43.1998C23.4138 43.1999 22.5094 42.8255 21.8425 42.1588C21.1756 41.4922 20.8009 40.5879 20.8008 39.645C20.8007 38.7021 21.1752 37.7977 21.8419 37.1309L36.9274 22.0442M25.7781 33.2435H35.7339M35.7339 20.7998L43.2008 28.266M40.7118 35.7323L42.5785 37.7232C42.8954 38.0825 43.1018 38.5255 43.1731 38.9991C43.2443 39.4727 43.1774 39.9568 42.9804 40.3934C42.7833 40.8299 42.4644 41.2003 42.062 41.4601C41.6596 41.7199 41.1908 41.8581 40.7118 41.8581C40.2328 41.8581 39.764 41.7199 39.3616 41.4601C38.9592 41.2003 38.6404 40.8299 38.4433 40.3934C38.2462 39.9568 38.1793 39.4727 38.2506 38.9991C38.3219 38.5255 38.5283 38.0825 38.8451 37.7232L40.7118 35.7323Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 60.5,
    r: 10.5,
    fill: "#C9DDC6",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8127 57.6375L57.192 57.2157C57.0203 57.0994 56.785 57.144 56.6701 57.3144L53.6277 61.8009L52.2296 60.4027C52.0835 60.2567 51.8456 60.2567 51.6995 60.4027L51.1681 60.9341C51.0221 61.0802 51.0221 61.3181 51.1681 61.4655L53.3181 63.6155C53.4384 63.7358 53.6277 63.8278 53.7981 63.8278C53.9684 63.8278 54.1402 63.7209 54.2511 63.56L57.9127 58.1581C58.029 57.9878 57.9844 57.7538 57.8127 57.6375Z",
    fill: "#7C9179"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodResultsIcon);
export default __webpack_public_path__ + "static/media/good-results-icon.5290b16fa547f7b59286eb55d0185334.svg";
export { ForwardRef as ReactComponent };